exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._21G1VcfCMhiCUTJ8Xwf62U{fill:currentColor}", ""]);

// exports
exports.locals = {
	"Svg": "_21G1VcfCMhiCUTJ8Xwf62U"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./website/Icon/Icon.css
 ** module id = 394
 ** module chunks = 0
 **/